<script setup>
import { useImageUpload } from '@utils';

const { uploadImageHandler } = useImageUpload();
const link = 'https://proctoring-api.univora.uz/services/platon-core/uploads/files/';
const emit = defineEmits(['uploaded']);

const uploadPhoto = async (event) => {
    const id = await uploadImageHandler(event, 'image');
    if (id) {
        emit('uploaded', link + id);
    }
};
</script>

<template>
    <label class="editor-image">
        <Icon name="image" class="icon" for="upload" />
        <input id="upload" type="file" class="hidden" @change.prevent="uploadPhoto" accept=".png, .jpg, .jpeg" />
    </label>
</template>

<style scoped>
.icon {
    @apply size-6;
}
.editor-image {
    @apply p-1 cursor-pointer;
    line-height: 0;
}
.editor-image:hover {
    @apply bg-gray-200 rounded-lg text-green-500;
}
</style>
